import { Alert, Slide, Snackbar, SnackbarCloseReason } from '@mui/material';
import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { clearMessage } from 'src/store/Message';

export const SnackbarComponent: React.FC = () => {
  const dispatch = useAppDispatch();
  const message = useAppSelector(state => state.message);
  const handleClose = () => {
    dispatch(clearMessage());
  };
  if (message.open) {
    return (
      <Snackbar
        sx={{ width: '98%' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={message.open}
        autoHideDuration={5000}
        TransitionComponent={props => <Slide {...props} direction="right" />}
        onClose={(_event, reason: SnackbarCloseReason) => {
          if (reason === 'timeout') {
            handleClose();
          }
        }}
      >
        <Alert onClose={handleClose} severity={message.severity}>
          {message.msgDetails}
        </Alert>
      </Snackbar>
    );
  }
  return null;
};
